export default __webpack_public_path__ + "static/media/space-3.0ef668d3.svg";